import {Box} from "@chakra-ui/react";
import RamPricingTables from "./ram";
import DiskSpacePricingTable from "./diskSpace";
import TrafficPricingTable from "./traffic";
import SSLandIp from "./ip";

const PaasPricingTables = () => {
  return (
    <Box>
      <RamPricingTables />
      <DiskSpacePricingTable />
      <TrafficPricingTable />
      <SSLandIp />
    </Box>
  );
};

export default PaasPricingTables;
